export class StringUtils {
  static camelCaseToSpaced(value: string): string {
    return value
      .replace(/([A-Z])/g, ' $1')
      .replace(/^./, (str: string) => str.toUpperCase());
  }

  static titleCase(value: string) {
    if (!value) {
      return '';
    }
    return value[0].toUpperCase() + value.substr(1).toLowerCase();
  }

  static snakeCaseToDashCase = (value: string) => value.replace(/_/g, '-');

  static humanizeTextCode = (value: string): string => {
    if (!value) {
      return value;
    }

    const isUppercase = value === value.toUpperCase();
    const spacedValue = isUppercase
      ? value.replace(/_/g, ' ')
      : '' + this.camelCaseToSpaced(value).trim();

    return StringUtils.titleCase(spacedValue);
  };
}
